import { useEffect, useState } from 'react'
import CircularProgress from '@mui/material/CircularProgress'
import IconButton from '@mui/material/IconButton'
import MUITextField from '@mui/material/TextField'
import CloseIcon from '@material-ui/icons/Close'
import Button from './Button'
import { Alert } from '../utils/Alert'
import { firestore } from '../firebase'
import { useAuthContext } from '../containers/AuthContextProvider'

export default function ChatConfig(props: {
	casinoId: string,
	onClickClose: () => void
}) {

	const { casinoId, onClickClose } = props

	const [systemInstruction, setSystemInstruction] = useState('')
	const [showLoader, setShowLoader] = useState(false)
	const [showSaveLoader, setShowSaveLoader] = useState(false)
	const { getUserInfo } = useAuthContext()

	useEffect(() => {
		fetchSettings()
	}, [casinoId])

	return (
		<div style={{
			padding: 20,
			width: '100%',
			boxSizing: 'border-box'
		}}>
			<div style={{
				display: 'flex',
				flexDirection: 'row',
				alignItems: 'center',
				justifyContent: 'space-between'
			}}>
				<h2>Chat Config</h2>
				<IconButton onClick={onClickClose}>
					<CloseIcon />
				</IconButton>
			</div>
			{showLoader ? (
				<div style={{
					padding: 30,
					display: 'flex',
					justifyContent: 'center'
				}}>
					<CircularProgress />
				</div>
			) : (
				<MUITextField
					style={{
						marginTop: 15,
						marginBottom: 15,
						width: '100%'
					}}
					variant='outlined'
					label='System Instruction'
					multiline
					minRows={16}
					value={systemInstruction}
					onChange={(e) => setSystemInstruction(e.target.value)} />
			)}
			<div style={{
				display: 'flex',
				flexDirection: 'row',
				alignItems: 'center',
				justifyContent: 'flex-end',
				gap: 10
			}}>
				{showSaveLoader && (
					<CircularProgress size={20} style={{ marginRight: 15 }} />
				)}
				<Button
					containerStyle={{
						width: 120,
						marginRight: 20
					}}
					type='outlined'
					disabled={showSaveLoader}
					onPress={onClickClose}
					title='Close' />
				<Button
					containerStyle={{
						width: 120
					}}
					disabled={showLoader || showSaveLoader}
					onPress={onPressSave}
					title='Save' />
			</div>
		</div>
	)

	function settingsDocRef() {
		return firestore().collection('casinos').doc(casinoId)
			.collection('settings').doc('ai-config')
	}

	async function fetchSettings() {
		setShowLoader(true)
		try {
			const docSnapshot = await settingsDocRef().get()
			setSystemInstruction(docSnapshot.data()?.systemInstruction ?? '')
		} catch (error) {
			Alert.alert('Error Fetching Chat Config', String(error))
		}
		setShowLoader(false)
	}

	async function onPressSave() {
		setShowSaveLoader(true)
		try {
			await settingsDocRef().set({
				systemInstruction,
				updatedAt: firestore.Timestamp.now(),
				updatedBy: getUserInfo()
			}, { merge: true })
		} catch (error) {
			Alert.alert('Error Saving Chat Config', String(error))
		}
		setShowSaveLoader(false)
	}
}
